import { FETCH_PURCHASE_ORDER_ITEMS } from '../actions/types'

export default (state = [], action) => {
  switch (action.type) {
    case FETCH_PURCHASE_ORDER_ITEMS:
      return action.payload
    default:
      return state
  }
}
